import React from "react";

const VerificationScreen = ({ text, secondText }) => {
  return (
    <div className="flex flex-col gap-4 items-center h-96 justify-center">
      <div className="w-max flex justify-center items-center">
        <div className="relative h-36 w-36 mt-2">
          <img src='success-animation.gif' alt="tick-icon" fill />
        </div>
      </div>
      <div className="flex flex-col gap-1 items-center">
        <h3 className="text-[#2A2F40] text-[1.375rem] md:text-[2rem] font-satoshi-black">
          {text}
        </h3>

        {secondText && (
          <h3 className="text-[#2A2F40] text-[1.375rem] md:text-[2rem] font-satoshi-black">
            {secondText}
          </h3>
        )}
      </div>
    </div>
  );
};

export default VerificationScreen;
